import { sampleProducts } from './SampleProducts'
import constants from '../../../common/restService/constant';
import GatewayGet from '../CommonServices/GatewayGet'

let props = {}
let inputObj = {}
let InputJSONString = ''
props['query'] = constants.serviceRoot
props['headers'] = constants.serviceHeaders

let data = [...sampleProducts]

const generateId = (data) =>
    data.reduce((acc, current) => Math.max(acc, current.ProductID), 0) + 1

export const insertItem = (item) => {
    item.ProductID = generateId(data)
    item.inEdit = false
    data.unshift(item)
    return data
}

// export const getItems = () => {
//     return data
// }

export const updateItem = async (data) => {
    
    InputJSONString = JSON.stringify(data)
    inputObj['Activity'] = 'XDOCK_EH_POST'
    inputObj['Input'] = InputJSONString
    props.input = inputObj
    const result = await GatewayGet(props, props.input)
    return result
}

export const retriggerItems = async (data) => {
    
    InputJSONString = JSON.stringify(data)
    inputObj['Activity'] = 'XDOCK_EH_POST_LTS'
    inputObj['Input'] = InputJSONString
    props.input = inputObj
    const result = await GatewayGet(props, props.input)
    return result
}

export const deleteItem = (item) => {
    let index = data.findIndex((record) => record.ProductID === item.ProductID)
    data.splice(index, 1)
    return data
}

export const BulkUploadData = async (inputData) => {
    InputJSONString = JSON.stringify(inputData)
    inputObj['Activity'] = 'XDOCK_EH_EXCEL_R'
    inputObj['Input'] = InputJSONString
    props.input = inputObj
    const result = await GatewayGet(props, props.input)
    return result
}


 